// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personalDataMain {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 77px 16px 110px 16px;
}

.personalDataContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #FFF4D9;
    padding: 33px 34px;
    position: relative;
    z-index: 99;
    border-radius: 16px;
    gap: 40px;
}
.createAdsUplodaImageButton {
    width: 100%;
    background: #FF6B00;
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    justify-content: center;
    height: 29px;
    border-radius: 8px;
    font-size: 16px;
    color: #FFF4D9;
    font-weight: 500;
}
.createAdsUplodaImageButtonHr {
    width: 100px;
    border: none;
    border-top: solid 1px #FFF4D9;
    margin-top: -2px;
}

.removePhotoButton {
    width: max-content;
    height: 44px;
    background: #FFB800;
    padding: 10px 20px;
    margin: 0 auto;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    color: #4B2D10;
    font-weight: 500;
    font-family: Alegreya Sans;
    cursor: pointer;
}

.personalDataTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: left;
    color: rgba(75, 45, 16, 1);
}

.personalDataButton {
    width: 100%;
    height: 44px;
    background: #FFB800;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    color: #4B2D10;
    font-weight: 500;
    font-family: Alegreya Sans;
    cursor: pointer;
}

.personalDataLilColumn {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: left;
    justify-content: left;
}

.personalDataSubtitle {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #4B2D10;
}

.persondalDataInput {
    background: none;
    border: none;
    border-bottom: solid 1px #B48100;
    height: 22px;
    width: 100%;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #4B2D10;
}

.persondalDataInput:focus,
.persondalDataTextArea:focus {
    outline: none;
}

.persondalDataTextArea {
    background: none;
    border: none;
    border-bottom: solid 1px #B48100;
    height: 52px;
    width: 100%;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #4B2D10;
}

.personalDataDropdown {
    position: relative;
    width: 100%;
}

.personalDataDropdownButton {
    width: 100%;
    border: none;
    background: none;
    height: 22px;
    border-bottom: solid 1px #B48100;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.personalDataDropdownMenu {
    position: absolute;
    width: 100%;
    margin-top: -1px;
    list-style: none;
    border: 1px solid #B48100;
    border-radius: 0 0 8px 8px;
    background-color: #FFF4D9;
    z-index: 1;
    padding: 0 0 12px 0;
    max-height: 240px;
    overflow: auto;
}

.dropdown-item {
    padding: 10px;
    cursor: pointer;
}

.personalDataDropdownButtonText {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #4B2D10;
}

.personalDataDropdownButtoMenuItem {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #4B2D10;
}

.personalDataDropdownMenuBox {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 15px 10px 0px 10px;
}

.personalDataDropdownMenuItemHr {
    border: none;
    border-top: solid 1px #B48100;
}

.personalDataDropdownLine {
    display: flex;
    flex-direction: row;
}

.persondalDataInputIcon {
    position: absolute;
    right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/PersonalData/PersonalData.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".personalDataMain {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 77px 16px 110px 16px;\n}\n\n.personalDataContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #FFF4D9;\n    padding: 33px 34px;\n    position: relative;\n    z-index: 99;\n    border-radius: 16px;\n    gap: 40px;\n}\n.createAdsUplodaImageButton {\n    width: 100%;\n    background: #FF6B00;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    align-items: center;\n    justify-content: center;\n    height: 29px;\n    border-radius: 8px;\n    font-size: 16px;\n    color: #FFF4D9;\n    font-weight: 500;\n}\n.createAdsUplodaImageButtonHr {\n    width: 100px;\n    border: none;\n    border-top: solid 1px #FFF4D9;\n    margin-top: -2px;\n}\n\n.removePhotoButton {\n    width: max-content;\n    height: 44px;\n    background: #FFB800;\n    padding: 10px 20px;\n    margin: 0 auto;\n    border-radius: 8px;\n    border: none;\n    font-size: 20px;\n    color: #4B2D10;\n    font-weight: 500;\n    font-family: Alegreya Sans;\n    cursor: pointer;\n}\n\n.personalDataTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: left;\n    color: rgba(75, 45, 16, 1);\n}\n\n.personalDataButton {\n    width: 100%;\n    height: 44px;\n    background: #FFB800;\n    border-radius: 8px;\n    border: none;\n    font-size: 20px;\n    color: #4B2D10;\n    font-weight: 500;\n    font-family: Alegreya Sans;\n    cursor: pointer;\n}\n\n.personalDataLilColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: left;\n    justify-content: left;\n}\n\n.personalDataSubtitle {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.persondalDataInput {\n    background: none;\n    border: none;\n    border-bottom: solid 1px #B48100;\n    height: 22px;\n    width: 100%;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.persondalDataInput:focus,\n.persondalDataTextArea:focus {\n    outline: none;\n}\n\n.persondalDataTextArea {\n    background: none;\n    border: none;\n    border-bottom: solid 1px #B48100;\n    height: 52px;\n    width: 100%;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.personalDataDropdown {\n    position: relative;\n    width: 100%;\n}\n\n.personalDataDropdownButton {\n    width: 100%;\n    border: none;\n    background: none;\n    height: 22px;\n    border-bottom: solid 1px #B48100;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.personalDataDropdownMenu {\n    position: absolute;\n    width: 100%;\n    margin-top: -1px;\n    list-style: none;\n    border: 1px solid #B48100;\n    border-radius: 0 0 8px 8px;\n    background-color: #FFF4D9;\n    z-index: 1;\n    padding: 0 0 12px 0;\n    max-height: 240px;\n    overflow: auto;\n}\n\n.dropdown-item {\n    padding: 10px;\n    cursor: pointer;\n}\n\n.personalDataDropdownButtonText {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.personalDataDropdownButtoMenuItem {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.personalDataDropdownMenuBox {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    padding: 15px 10px 0px 10px;\n}\n\n.personalDataDropdownMenuItemHr {\n    border: none;\n    border-top: solid 1px #B48100;\n}\n\n.personalDataDropdownLine {\n    display: flex;\n    flex-direction: row;\n}\n\n.persondalDataInputIcon {\n    position: absolute;\n    right: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
